import React from 'react';
import { GiftIcon } from '@heroicons/react/24/outline';
import { formatCurrency } from '../../utils/baseUtils';

// /register sayfasında, geçerli bir davet kodu varsa davet eden restoranı gösterir.
const ReferralInviteBanner = ({ referrer }) => {
  if (!referrer?.valid) return null;

  return (
    <div className="mb-5 flex items-center gap-3 rounded-xl border border-blue-200 bg-blue-50 px-4 py-3 dark:border-sky-500/30 dark:bg-sky-500/10 sm:mb-6">
      {referrer.referrercompanylogo ? (
        <img
          src={referrer.referrercompanylogo}
          alt={referrer.referrercompanyname || 'Referrer'}
          className="h-10 w-10 shrink-0 rounded-full object-cover ring-1 ring-blue-200 dark:ring-sky-500/30"
        />
      ) : (
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-blue-100 text-blue-600 dark:bg-sky-500/20 dark:text-sky-300">
          <GiftIcon className="h-5 w-5" />
        </span>
      )}
      <div className="min-w-0">
        <p className="text-sm font-semibold text-slate-900 dark:text-slate-100">
          {referrer.referrercompanyname
            ? `${referrer.referrercompanyname} invited you to Thisway`
            : 'You were invited to Thisway'}
        </p>
        <p className="text-xs text-slate-600 dark:text-slate-300">
          Sign up and you&apos;ll both get{' '}
          {formatCurrency(referrer.rewardamount || 0)} in credits.
        </p>
      </div>
    </div>
  );
};

export default ReferralInviteBanner;
